// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","AdSlotBranding__desktopWrap":"bhg_a","AdSlotBranding__desktop":"bhg_b","AdSlotBranding__mobile":"bhg_c"};